<template>
  <section>
    <b-row>
      <b-col md="6">
        <expired-certificates />
      </b-col>
      <b-col
        v-if="$can('Read', 'Invoice')"
        md="6"
      >
        <pending-received-invoices />
      </b-col>
      <b-col
        v-for="permitLicenseType in permitLicensesTypes()"
        :key="permitLicenseType.label"
        md="6"
      >
        <current-permit-licenses :permit-license-type="permitLicenseType" />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import isElectron from 'is-electron'
import { hasErpAccess } from '@/auth/utils'
import { BRow, BCol } from 'bootstrap-vue'
import { payboxConfiguration, companyDomains } from '@/mixins'
import ExpiredCertificates from './components/dashboard/ExpiredCertificates.vue'
import CurrentPermitLicenses from './components/dashboard/CurrentPermitLicenses.vue'
import PendingReceivedInvoices from './components/dashboard/PendingReceivedInvoices.vue'

export default {
  components: {
    ExpiredCertificates,
    BRow,
    BCol,
    CurrentPermitLicenses,
    PendingReceivedInvoices,
  },
  mixins: [payboxConfiguration, companyDomains],
  async mounted() {
    if (isElectron() && !hasErpAccess()) {
      if (this.isPdvInactive) {
        this.$router.replace({ name: 'pdv-pay-box-inactive' })
        return
      }

      this.mxPdvRouteRedirect()
    }
  },
}
</script>

<style></style>
